import React, { useContext, useMemo, useState } from "react";
import RoundedRectangle from "../../../components/RoundedRectangle";
import { translate } from "../../../../config/translator";
import MatchdaySelector from "../../../components/MatchdaySelector";
import TOTW from "../../../components/TOTW";
import { ClavaContext } from "../../../../config/contexts";
import { League } from "../../../../client/api";
import { GridSelectorItem } from "../../../components/GridSelector";

type LeagueTotwViewProps = {
  isVisible: boolean;
  hasTotwRestriction: boolean;
  league: League;
};

const LeagueTotwView: React.FC<LeagueTotwViewProps> = ({
                                                         isVisible,
                                                         hasTotwRestriction,
                                                         league
                                                       }) => {
  const { l } = useContext(ClavaContext);
  const [matchday, setMatchday] = useState<number | undefined>(league.currentMatchDay);
  const matchdayItems = useMemo<GridSelectorItem<number>[]>(() => Array(league.matchDays).fill(0).map((_, i) => ({
        key: i + 1,
        label: `${i + 1}. ${translate("matchDay", l)}`
      })), [league.matchDays, l]);
  const currentMatchdayLabel = useMemo(() => matchdayItems.find(md => md.key === matchday)?.label, [matchday, matchdayItems]);
  if (!isVisible) return null;
  return (
    <div>
      <RoundedRectangle
        className="rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark mb-4  w-full"
        hasBorder
        hasTitle={false}
      >
        <div className="py-4 px-4 text-left">
          <h2 className="text-base font-medium text-font dark:text-font-dark">Team of the Week</h2>
        </div>
        <div className="p-4">
          <div className="flex justify-start">
            <div className="w-auto">
              {hasTotwRestriction ? (
                <div
                  className="relative overflow-hidden h-12 flex-shrink-0 inline-flex items-center justify-start rounded-lg bg-white dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark px-3 text-left text-font dark:text-font-dark">
                  <span className="truncate">{currentMatchdayLabel ?? translate("matchDay", l)}</span>
                </div>
              ) : (
                <MatchdaySelector
                  value={matchday}
                  onChange={setMatchday}
                  items={matchdayItems}
                  placeholder={translate("select", l)}
                  transparent
                  withoutChoose
                  containerClassName="relative overflow-hidden h-12 flex-shrink-0 inline-flex items-center justify-start rounded-lg bg-white dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark pl-3 pr-10"
                  className="text-left"
                />
              )}
            </div>
          </div>
        </div>
        {!!matchday && (
          <TOTW leagueId={league.id} matchDay={matchday} />
        )}
      </RoundedRectangle>
    </div>
  );
};

export default LeagueTotwView;
